import { DeviceCreateDto } from './device-create.dto';
import { DeviceSubscriptionInterface } from '../interfaces/device-subscription.interface';

export class DeviceSubscriptionDto
  extends DeviceCreateDto
  implements DeviceSubscriptionInterface {}
